/** Damped spring — gives motion a slight, organic overshoot instead of linear easing. */
export class Spring {
  value = 0;
  velocity = 0;

  constructor(
    public stiffness: number,
    public damping: number,
  ) {}

  update(target: number, dt: number): number {
    const accel = (target - this.value) * this.stiffness - this.velocity * this.damping;
    this.velocity += accel * dt;
    this.value += this.velocity * dt;
    return this.value;
  }
}
